export default "__VITE_ASSET__Cd69mYSC__"